import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import * as serviceWorkerRegistration from "@/serviceWorkerRegistration";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Makes the app shell itself loadable with zero network (on top of the scan-data offline
// support in src/lib/offlineStore.js) — see serviceWorkerRegistration.js and
// public/service-worker.js.
serviceWorkerRegistration.register();
